module.exports = __webpack_public_path__ + "static/media/adv3.ab5db9fc.jpg";